import React from 'react';
import CTAButton from './CTAButton';
export function BenefitsSection() {
  return <section className="py-6 px-4 bg-gradient-to-b from-green-50 to-white" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-5 rounded-lg shadow-lg mb-4" data-id="element-14">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-3 text-center" data-id="element-15">
            💥 RESULTADO FINAL
          </h2>
          <p className="text-xl text-white mb-3" data-id="element-16">Imagina esto…</p>
          <p className="text-xl text-white mb-2" data-id="element-17">Tu hijo:</p>
          <ul className="space-y-2" data-id="element-18">
            <li className="flex items-start" data-id="element-19">
              <span className="text-yellow-300 font-bold text-2xl mr-3" data-id="element-20">
                ✔
              </span>
              <span className="text-xl text-white" data-id="element-21">
                Sabe qué hacer con su dinero
              </span>
            </li>
            <li className="flex items-start" data-id="element-22">
              <span className="text-yellow-300 font-bold text-2xl mr-3" data-id="element-23">
                ✔
              </span>
              <span className="text-xl text-white" data-id="element-24">Tiene metas</span>
            </li>
            <li className="flex items-start" data-id="element-25">
              <span className="text-yellow-300 font-bold text-2xl mr-3" data-id="element-26">
                ✔
              </span>
              <span className="text-xl text-white" data-id="element-27">No compra por impulso</span>
            </li>
            <li className="flex items-start" data-id="element-28">
              <span className="text-yellow-300 font-bold text-2xl mr-3" data-id="element-29">
                ✔
              </span>
              <span className="text-xl text-white" data-id="element-30">
                Entiende cómo generar valor
              </span>
            </li>
          </ul>
          <p className="text-xl text-white font-bold mt-3" data-id="element-31">
            👉 Eso cambia su futuro completamente.
          </p>
        </div>

        <div className="bg-red-50 p-5 rounded-lg shadow-lg mb-4" data-id="element-32">
          <h3 className="text-2xl md:text-4xl font-black text-red-600 mb-3" data-id="element-33">
            ⚠️ SI NO HACES NADA…
          </h3>
          <p className="text-xl mb-2" data-id="element-34">Tu hijo crecerá como la mayoría:</p>
          <ul className="space-y-2" data-id="element-35">
            <li className="flex items-start" data-id="element-36">
              <span className="text-red-600 font-bold mr-3" data-id="element-37">❌</span>
              <span className="text-lg" data-id="element-38">Sin educación financiera</span>
            </li>
            <li className="flex items-start" data-id="element-39">
              <span className="text-red-600 font-bold mr-3" data-id="element-40">❌</span>
              <span className="text-lg" data-id="element-41">Repitiendo errores</span>
            </li>
            <li className="flex items-start" data-id="element-42">
              <span className="text-red-600 font-bold mr-3" data-id="element-43">❌</span>
              <span className="text-lg" data-id="element-44">Aprendiendo con frustración</span>
            </li>
          </ul>
        </div>

        <CTAButton text="¡QUIERO DARLE ESA VENTAJA A MI HIJO!" data-id="element-45" />
      </div>
    </section>;
}
export default BenefitsSection;